import * as React from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router-dom";
import "Loans/styles.scss";
import * as moment from "moment";
import {useEffect, useState} from "react";
import BasicCard from "myshubhlife-component/card";
import {COLOR, whatsAppLink, CC_EMAIL_ID} from "utils/variables";
import {CardRow, NACH_STATUS, NACH_STATUS_TEXT, REPAYMENT_ACCOUNT_TEXT, RepaymentLink} from "Loans/utils";
import ContainerBox from "myshubhlife-component/container-box";
import {Loan, LoanInfo} from "Loans/interface";
import {IRepaymentDetail} from "StateInterface";
import {CopyToClipBoard, Button} from "web-com";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";
import "./styles.scss";
import {AndroidApis} from "app";
import PaymentConfirmPopup from "Loans/LoanList/DisbursalInfo/PaymentConfirmPopup";

interface IConnectProps {
    isAndroid: boolean;
    loanIndex: number;
    loanList: Loan[];
    apiVersion: number;
}

interface Details {
  title: string;
  value: string | number;
}

interface RepaymentSchedule extends IRepaymentDetail {
  paid_date: number;
}

enum Status {
  DISBURSED = "DISBURSED",
  CLOSED = "CLOSED",
  PRE_CLOSED = "PRE_CLOSED",
}
export interface LenderInfo {
    customerCarePortal: "";
    email: string;
    iconUrl: string;
    name: string;
    phoneNumber: string;
    website: string;
}

const DisbursalInfo = (props: IConnectProps & RouteComponentProps) => {
    const [loanInfo, updateLoanInfo] = useState<Details[]>(null);
    const [bankActDetails, updateBankActDetails] = useState<Details[]>(null);
    const [loan, updateLoan] = useState <LoanInfo & {is_expired: boolean, is_closed: boolean}> (null);
    const [repaySchedules, updateRepaySchedules] = useState<RepaymentSchedule[]>(null);
    const [lenderInfo, updateLenderInfo] = useState<LenderInfo>(null);
    const [isOpen, updateIsOpen] = useState(false);
    const [upcomingSchedule, updateUpcomingSchedule] = useState<RepaymentSchedule[]>(null);
    const tags = props.loanList[props.loanIndex]?.state?.tags;
    const EKAGRATA = "Ekagrata";
    useEffect(() => {
        if (props.isAndroid) {
            props.apiVersion >= 208 ? AndroidApis.newOpenRating(false, true, true) : AndroidApis.openRating(true, true);
            AndroidApis.toolBarConfig({
                visibility: true,
                whatsAppLink,
                menuItems: {
                    action_whatsApp: true,
                    action_chat: false,
                },
            });
        }
    }, []);

    useEffect(() => {
      if (props.loanList && props.loanList.length) {
        const loanDetail = {
            ...props.loanList[props.loanIndex].state.loan_detail.loanDetail,
            cd: props.loanList[props.loanIndex].state.cd,
            is_expired: props.loanList[props.loanIndex].state.is_expired,
            is_closed: props.loanList[props.loanIndex].state.is_closed,
        };

        const info = [
            {
                title: "Amount",
                value: `₹ ${loanDetail.amount}`,
            },
              {
                title: "Tenure",
                value: `${loanDetail.tenureMonths} Months`,
            },
              {
                title: "EMI",
                value: `₹ ${Math.round(loanDetail.emiAmount)}`,
            },
              {
                title: "EMI start date",
                value: loanDetail.emiStartDate ? moment(Number(loanDetail.emiStartDate)).format("DD/MM/YYYY") : "-",
            },
              {
                title: "Disbursal Date",
                value: loanDetail.disbursalDate ? moment(Number(loanDetail.disbursalDate)).format("DD/MM/YYYY") : "-",
            },
              {
                title: "Advance Interest",
                value: `₹ ${loanDetail.brokenInterest ? loanDetail.brokenInterest : 0}`,
            },
            {
                title: "Processing Fee (Excluding GST)",
                value: `₹ ${loanDetail.processingFee}`,
            },
            ...(loanDetail.cd && loanDetail.cd > 0 ? [{
                title: "Total Charges Due",
                value: `₹ ${loanDetail.cd.toFixed(2)}`,
            }] : []),
        ];
        const bankAccountDetails = loanDetail.repaymentAccountDetails && [
            {
                title: "Beneficiary Name",
                value: loanDetail.repaymentAccountDetails.beneficiaryName,
            },
            {
                title: "Bank Name",
                value: loanDetail.repaymentAccountDetails.bankName,
            },
            {
                title: "Account No",
                value: loanDetail.repaymentAccountDetails.bankAccountNumber,
            },
            {
                title: "IFSC",
                value: loanDetail.repaymentAccountDetails.ifscCode,
            },
            {
                title: "Account Type",
                value: loanDetail.repaymentAccountDetails.bankAccountType,
            },
        ];
        updateLoan(loanDetail);
        updateBankActDetails(bankAccountDetails);
        updateLoanInfo(info);
        updateRepaySchedules(props.loanList[props.loanIndex].state["repayment_schedules"]);
        updateLenderInfo(props.loanList[props.loanIndex]["lender_info"]);
      }
    }, [props.loanList]);

    const redirectToRepayment = () => {
      if (props.isAndroid) {
        setAndroidTokenAndVersionBeforeRedirecting(props.apiVersion, getIdToken());
      }
      window.open(`${(lenderInfo.name !== EKAGRATA && loan.repaymentAccountDetails["repaymentLink"]) || RepaymentLink[lenderInfo.name.toUpperCase()]}${
        lenderInfo.name === EKAGRATA ? `?loan_id=${loan.loanId}&amount=${loan["emiAmount"]}` : ""}`);
    };

    const shouldShowPaymentConfirmPopup  = () => {
        const dueDate = repaySchedules.filter((d: RepaymentSchedule) => {
          const diffDate = Math.ceil((new Date(d.date).getTime() - new Date().getTime())  / (1000 * 60 * 60 * 24));
          return diffDate < 3 && diffDate >= 0;
        });
        updateUpcomingSchedule(dueDate);
        return (lenderInfo.name === EKAGRATA && dueDate.length &&
        loan.status.toUpperCase() === Status.DISBURSED &&
        loan.nachStatus === NACH_STATUS.ACTIVATED);
    };

    const lenderInfoStyle = {
        marginBottom : props.isAndroid ? 60 : 0,
    };
    return(
        <>
          {loanInfo && loanInfo.length &&
            <ContainerBox pageTitle={!props.isAndroid ? "Loan Details" : ""} showBackButton={true}>
                <BasicCard headerTitle={"Loan Details"}>
                    <div className="details-container">
                        {
                            loanInfo.map((info, index) => {
                                return <CardRow title={info.title} value={info.value} key={index}/>;
                            })
                        }
                    </div>
                </BasicCard>
                {loan.is_expired && !loan.is_closed &&
                  <div className="expired-info-container">
                    <BasicCard>
                      <h6 style={{color: COLOR.PRIMARY}}>Your loan is matured</h6>
                      <div className="expired-info">
                        Please contact&nbsp;
                        <a style={{color: COLOR.PRIMARY}} href={`mailto:${CC_EMAIL_ID}`}> {CC_EMAIL_ID}</a>&nbsp;
                        to apply for another loan.
                      </div>
                    </BasicCard>
                  </div>
                }
                <div className="clipboard-container">
                  <CopyToClipBoard text={loan.lenderLoanAcctId}>
                      <p className="lan-detail">
                          Your Loan Account Number (LAN): {loan.lenderLoanAcctId}
                      </p>
                  </CopyToClipBoard>
                </div>
                {!loan.is_closed && <Button
                  buttonText="Pay"
                  onClick={() => shouldShowPaymentConfirmPopup() ? updateIsOpen(true) : redirectToRepayment()}
                  fontWeight="bold"
                  maxWidth={95}
                />}
                <PaymentConfirmPopup
                  isOpen={isOpen}
                  dueDate={upcomingSchedule && upcomingSchedule.length && upcomingSchedule[0].date}
                  onClose={() => updateIsOpen(false)}
                  onSubmit={() => {redirectToRepayment(); updateIsOpen(false); }}
                />
                {
                    loan["repaymentAccountDetails"] &&
                    loan.nachStatus !== NACH_STATUS.ACTIVATED &&
                    (lenderInfo && !RepaymentLink[lenderInfo.name.toUpperCase()]) &&
                    <div className="bank-info-container">
                        <BasicCard bodyBackgroundColor={COLOR.PRIMARY} bodyTextColor={COLOR.WHITE}>
                            {
                                REPAYMENT_ACCOUNT_TEXT.hasOwnProperty(loan.nachStatus) &&
                                <p>{REPAYMENT_ACCOUNT_TEXT[loan.nachStatus]}</p>
                            }
                            <div className="bank-details">
                                {
                                    bankActDetails.map((info, index) => {
                                        return <CardRow title={info.title} value={info.value} key={index}/>;
                                    })
                                }
                            </div>
                            <span style={{fontSize: 13}}>
                            *Please ignore if you have already paid the EMI
                        </span>
                        </BasicCard>
                    </div>
                }
                {tags?.includes("written-off") &&
                    <div style={{color: "#F5821F", textAlign: "center", padding: 10}}>
                       {tags.includes("closed") ? "Your loan has been closed and all dues are paid!" : "Your account is now overdue, please pay your dues"}
                    </div>
                }
                 {!tags?.includes("written-off") && !!(repaySchedules && repaySchedules.length > 0) &&
                  <div className="emi-calender-container">
                    <h6 style={{color: COLOR.PRIMARY, textAlign: "center", marginTop: 30}}>EMI Calendar</h6>
                    <div className="emi-table">
                        {
                            repaySchedules.map((emiDetails, index) => {
                                return(
                                    <div className="emi-card"
                                         key={index}
                                         style={{
                                             backgroundColor: emiDetails.paid_date ? COLOR.PRIMARY : "transparent",
                                             color: emiDetails.paid_date ? COLOR.WHITE : COLOR.GRAY,
                                             border: emiDetails.paid_date ? "none" : `1px solid ${COLOR.DARK_GRAY}`,
                                         }}
                                    >
                                        <p className="year">{moment(Number(emiDetails.date)).format("YYYY")}</p>
                                        <p className="date">
                                            {moment(Number(emiDetails.date)).format("MMM").toUpperCase() +
                                            " - " + moment(Number(emiDetails.date)).format("D")}
                                        </p>
                                        {
                                            emiDetails.paid_date &&
                                            <span className="paid-status"
                                                  style={{backgroundColor: COLOR.OFF_WHITE, color: COLOR.BLACK}}>
                                       Paid
                                   </span>
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div style={{padding: 8, fontSize: 15}}>
                        *T&C - Additional charges apply on EMI(s) bounced / delayed beyond the due date.
                    </div>
                  </div>
                }
                {
                    lenderInfo &&
                    <div className={`lender-info-container`} style={lenderInfoStyle}>
                        <BasicCard>
                                <h6 style={{color: COLOR.PRIMARY}}>Loan Provided By</h6>
                                <div className="lender-info">
                                    <div>
                                        <img src={lenderInfo.iconUrl}
                                             width={"110"}
                                             alt={"icon"}
                                        />
                                    </div>
                                    <div>
                                        <p>{lenderInfo.email}</p>
                                        <p>{lenderInfo.phoneNumber}</p>
                                    </div>
                                </div>
                        </BasicCard>
                    </div>
                }
                {
                    loan.nachStatus &&
                    NACH_STATUS_TEXT[loan.nachStatus] &&
                    (loan.status !== Status.CLOSED && loan.status !== Status.PRE_CLOSED) &&
                    <div className="nach-status"
                         style={{
                             backgroundColor: COLOR.PRIMARY,
                             color: COLOR.WHITE,
                             position: props.isAndroid ? "fixed" : "relative",
                         }}>
                        <span>{NACH_STATUS_TEXT[loan.nachStatus]}</span>
                    </div>
                }
            </ContainerBox>
           }
        </>
    );
};

const mapStateToProps = (state): IConnectProps => {
    return {
        isAndroid: state.login.isAndroid,
        loanIndex: state.loanDetails["loanIndex"],
        loanList: state.loanDetails["loansList"] ? state.loanDetails["loansList"] : [],
        apiVersion: state.login.apiVersion,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(DisbursalInfo);
